import '@/assets/scss/main.scss';
import '@/sections/tariffs-section.js';
import { App } from '@roskvartal-landings/base';
import {
  MaskPlugin,
  ModalPlugin,
  LazrPlugin
} from '@/plugins';
import {
  Modal,
  TextField,
  LeadModal,
  UserTypeModal,
  Accordion,
  MapComponent,
  Navbar
} from '@/components';

const landingApp = new App();

landingApp.usePlugin(MaskPlugin);
landingApp.usePlugin(ModalPlugin);
landingApp.usePlugin(LazrPlugin);
landingApp.registerComponent('text-field', TextField);
landingApp.registerComponent('lead-modal', LeadModal);
landingApp.registerComponent('user-type-modal', UserTypeModal);
landingApp.registerComponent('modal', Modal);
landingApp.registerComponent('accordion', Accordion);
landingApp.registerComponent('navbar', Navbar);

landingApp.init();

new Accordion({
  section: 'c-accordion-section',
  container: 'c-accordion-section-item',
  selected: 'c-accordion-section-item@selected',
  button: 'c-accordion-section-item',
  content: 'c-accordion-section-item-body'
});